import { episodeAggregateSagas } from './episodes';
import { podcastAggregateSagas } from './podcasts';

export const aggregateSagas = [
  ...episodeAggregateSagas,
  ...podcastAggregateSagas,
];
